export enum ProviderCode {
  CLICK_FUNNELS = 'cf',
  CLICK_FUNNELS_CLASSIC = 'cf-classic',
  ZAPIER_CODE = 'zapier',
  GO_HIGH_LEVEL = 'ghl',
  STRIPE = 'stripe',
  MAKE = 'make',
  PABBLY = 'pabbly',
  JOBADDER = 'jobadder',
  HUBSPOT = 'hubspot',
  WORDPRESS = 'wordpress',
  ACTIVE_CAMPAIGN = 'activecampaign',
}

export interface ExternalProvider {
  createdAt: string
  _id: string
  code: string
  name: string
  image: string
}

export interface IntegrationAppData {
  teamId: string
  teamName: string
  workspaceId: string
  workspaceName: string
  workspaceDomain: string
  apiKey: string
  webhookId: number

  accessToken: string
  refreshToken: string
  scope: string
  expiresIn: string
  userType: string
  companyId: string
  locationId: string
  userId: string
  smsSender: string
  mmsSender: string

  usSmsSender: string
  usMmsSender: string

  jobadder: {
    _id: string
    accessToken: string
    refreshToken: string
    scope: string
    expiresIn: string
    accountId: string
    smsSender: string
    eventType: EventTypeData[]
    contactImport: boolean
    contactExport: boolean
  }

  hubspot: {
    _id: string
    accessToken: string
    refreshToken: string
    expiresIn: string
    smsSender: string
    phoneNumberField: string
  }

  stripe: {message: string; eventType: string}[]

  activecampaign: {
    apiUrl: string
    apiKey: string
    appKey?: string
  }
}

export interface EventTypeData {
  _id: string
  eventType: string
  message: string
}

export interface IntegrationApp {
  data: IntegrationAppData
  features: string[]
  createdAt: string
  _id: string
  externalProvider: string
  user: string
  internalApiKeyName: string
  // only available for click funnels classic
  internalApiToken?: string
}

export interface IntegrationPageState {
  externalProviders: ExternalProvider[]
  activeIntegration: IntegrationApp[]
  selectedExternalProvider: ExternalProvider | null
  selectedActiveIntegration: IntegrationApp | null
  refetch: boolean | null
  activeIntegrationIDs: string[]
}

export interface IntegrationPageSlice {
  integration: IntegrationPageState
}

export interface SelectActiveIntegrationPaylod {
  externalProviderId: string
  userId: string
}
